module.exports = __webpack_public_path__ + "static/PeterBlochJohansen-c37c44be00a5e6584bce563feca21e32.jpg";